import {Component, HostBinding, Input} from '@angular/core';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    standalone: false
})
export class ButtonComponent {
    @HostBinding('class.leading-0') leadingZero = true;
    @HostBinding('class.shrink-0') noFlexShrink = true;
    @Input() ariaLabel: string | null = null;
}
